export default "__VITE_ASSET__DIP3rRw1__"